import React from "react";
import { Switch, Route } from "react-router-dom";
import { Layout } from "antd";
import routes from "../../../../routes";
import "./style.css";
import LabsTopMenu from "../../../components/LabsTopMenu";
import OrderDetails from "./OrderDetails";
import OrderListing from "./OrderListing";
import ReportUpload from "./ReportUpload";
import ReUploadReport from "./ReUploadReport";
import SampleReceived from "./SampleReceived";
import ReviewReports from "./ReviewReports";
import ReviewReport from "./ReviewReport";
import LabDashboard from "./LabDashboard";
import CommodityOrdersStatusOverview from "./CommodityOrdersDetailed";

const { Header, Content } = Layout;

const LabModuleApp = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <Layout>
        <Header className="labLayoutHeader">{<LabsTopMenu />}</Header>
        <Content className="labMainContainer">
          <Switch>
            <Route
              exact
              path={routes.labs.labDashboard.view}
              component={LabDashboard}
            />
            <Route
              exact
              path={routes.labs.labDashboard.details.commodityOrderDetails}
              component={CommodityOrdersStatusOverview}
            />
            <Route
              exact
              path={routes.labs.dashboard}
              component={OrderListing}
            />
            <Route
              exact
              path={routes.labs.reviewReports.list}
              component={ReviewReports}
            />
            <Route
              exact
              path={routes.labs.reviewReports.review}
              component={ReviewReport}
            />
            <Route
              exact
              path={routes.labs.orders.details.view}
              component={OrderDetails}
            />
            <Route
              exact
              path={routes.labs.orders.details.uploadReport}
              component={ReportUpload}
            />
            <Route
              exact
              path={routes.labs.orders.details.reuploadReport}
              component={ReUploadReport}
            />
            <Route
              exact
              path={routes.labs.orders.details.sampleReceived}
              component={SampleReceived}
            />
          </Switch>
        </Content>
      </Layout>
    </div>
  );
};

export default LabModuleApp;
